<template>
  <div
    class="payable-list-main-wrapper cbg-white-container theme--light v-card border-card input-container"
  >
    <CCol sm="12">
      <CRow>
        <CCol sm="3" class="form-group search-div form-mar-grp mb-0">
          <label for>Use same utility charges for all roles %</label>
          <input
            v-model.number="utilityChargesPercentage"
            type="text"
            class="form-control"
            placeholder="Charges in percentage"
          />
        </CCol>
        <CCol sm="12">
          <v-btn @click="updatePercentage" class="btn btn-primary">Save</v-btn>
        </CCol>
      </CRow>

      <CRow>
        <CCol sm="12">
          <div>
            <v-tabs
              v-model="tabs"
              background-color="transparent"
              class="border-bottom"
            >
              <v-tab v-for="(item, i) in items" :key="i" @change="changeTab(i)">
                {{ item.tabName }}
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tabs">
              <!-- .......... Doctor......... -->
              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <div v-if="tabs === 0 && showPage">
                      <account-setting-tabs
                        :accountData="accountDataForDoctorRole"
                        :index="currentIndex"
                        :tabs="tabs"
                      />
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <!-- .......... Allied......... -->
              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <div v-if="tabs === 1 && showPage">
                      <account-setting-tabs
                        :accountData="accountDataForAlliedRole"
                        :index="currentIndex"
                        :tabs="tabs"
                      />
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <!-- .......... Pharmacy......... -->
              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <div v-if="tabs === 2 && showPage">
                      <account-setting-tabs
                        :accountData="accountDataForPharmacyRole"
                        :index="currentIndex"
                        :tabs="tabs"
                      />
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <!-- .......... Docsmart......... -->
              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <div v-if="tabs === 3 && showPage">
                      <account-setting-tabs
                        :accountData="accountDataForDocsmartRole"
                        :index="currentIndex"
                        :tabs="tabs"
                      />
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <!-- .......... Diagnostics ......... -->
              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <div v-if="tabs === 4 && showPage">
                      <account-setting-tabs
                        :accountData="accountDataForDiagnosticRole"
                        :index="currentIndex"
                        :tabs="tabs"
                      />
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <!-- .......... Bloodbank ......... -->
              <!-- <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <div v-if="tabs === 5 && showPage">
                      <account-setting-tabs
                        :accountData="accountDataForBloodbankRole"
                        :index="currentIndex"
                        :tabs="tabs"
                      />
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item> -->
              <!-- .......... Ambulance ......... -->
              <!-- <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <div v-if="tabs === 6 && showPage">
                      <account-setting-tabs
                        :accountData="accountDataForAmbulanceRole"
                        :index="currentIndex"
                        :tabs="tabs"
                      />
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item> -->
              <!-- .......... Hospital ......... -->
              <!-- <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <div v-if="tabs === 6"><account-setting-tabs /></div>
                  </v-card-text>
                </v-card>
              </v-tab-item> -->
            </v-tabs-items>
          </div>
        </CCol>
      </CRow>
    </CCol>
  </div>
</template>
<script>
import Config from "@/config.js";
const API_URL = `${Config.ACCOUNTS_URL}ds-accounts-be`;
export default {
  components: {
    "account-setting-tabs": () =>
      import("@/views/dashboardNew/Accounts/accountSettingTabs"),
  },
  data: function() {
    return {
      utilityChargesPercentage: null,
      tabs: 0,
      items: [
        { tabName: "Doctor" },
        { tabName: "Allied" },
        { tabName: "Pharmacy" },
        { tabName: "Docsmart" },
        { tabName: "Diagnostic" },
        // { tabName: "Bloodbank" },
        // { tabName: "Ambulance" },
        // { tabName: "Hospital" },
      ],
      accountDataForDoctorRole: {
        utilityCharge: 50,
        cancellationCharge: 50,
        sameAsUtilityCharge: true,
        videoFees: 100,
        appointmentType: "APPOINTMENT",
      },
      accountDataForAlliedRole: {
        utilityCharge: 50,
        cancellationCharge: 50,
        sameAsUtilityCharge: true,
        videoFees: 100,
        appointmentType: "APPOINTMENT",
      },
      accountDataForPharmacyRole: {
        utilityCharge: 50,
        cancellationCharge: 50,
        sameAsUtilityCharge: true,
        appointmentType: "PHARMACY_BOOKING",
      },
      accountDataForDiagnosticRole: {
        utilityCharge: 50,
        cancellationCharge: 50,
        sameAsUtilityCharge: true,
        appointmentType: "DIAGNOSTIC_BOOKING",
      },
      // accountDataForBloodbankRole: {
      //   utilityCharge: 50,
      //   cancellationCharge: 50,
      //   sameAsUtilityCharge: true,
      //   appointmentType: "BLOODBANK_BOOKING",
      // },
      // accountDataForAmbulanceRole: {
      //   utilityCharge: 50,
      //   cancellationCharge: 50,
      //   sameAsUtilityCharge: true,
      //   appointmentType: "AMBULANCE_BOOKING",
      // },
      accountDataForDocsmartRole: {
        utilityCharge: 50,
        cancellationCharge: 50,
        sameAsUtilityCharge: true,
      },
      currentIndex: 0,
      showPage: false,
    };
  },
  created() {
    this.fetchAcountSetting();
  },
  methods: {
    changeTab(index) {
      this.tabs = index;
      this.currentIndex = 0;
      this.showPage = false;
      this.accountDataForDoctorRole = {
        utilityCharge: 50,
        cancellationCharge: 50,
        sameAsUtilityCharge: true,
        videoFees: 100,
        appointmentType: "APPOINTMENT",
      };
      this.accountDataForAlliedRole = {
        utilityCharge: 50,
        cancellationCharge: 50,
        sameAsUtilityCharge: true,
        videoFees: 100,
        appointmentType: "APPOINTMENT",
      };
      this.accountDataForPharmacyRole = {
        utilityCharge: 50,
        cancellationCharge: 50,
        sameAsUtilityCharge: true,
        appointmentType: "PHARMACY_BOOKING",
      };
      this.accountDataForDocsmartRole = {
        utilityCharge: 50,
        cancellationCharge: 50,
        sameAsUtilityCharge: true,
      };
      this.accountDataForDiagnosticRole = {
        utilityCharge: 50,
        cancellationCharge: 50,
        sameAsUtilityCharge: true,
        appointmentType: "DIAGNOSTIC_BOOKING",
      };
      // this.accountDataForBloodbankRole = {
      //   utilityCharge: 50,
      //   cancellationCharge: 50,
      //   sameAsUtilityCharge: true,
      //   appointmentType: "BLOODBANK_BOOKING",
      // };
      // this.accountDataForAmbulanceRole = {
      //   utilityCharge: 50,
      //   cancellationCharge: 50,
      //   sameAsUtilityCharge: true,
      //   appointmentType: "AMBULANCE_BOOKING",
      // };
      this.fetchAcountSetting();
    },
    updatePercentage() {
      let url = `${API_URL}/v2/admin/update-global-utility-settings`;
      let payload = {
        amount: this.utilityChargesPercentage,
      };
      this.$http.post(url, payload).then(
        (response) => {
          if (response.body.status) {
            this.fetchAcountSetting();
            this.$swal({
              text: response.body.message,
              icon: "success",
              allowOutsideClick: false,
              showCancelButton: false,
              confirmButtonText: "Ok",
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    fetchAcountSetting() {
      let role =
        this.tabs === 0
          ? "doctor"
          : this.tabs === 1
          ? "allied"
          : this.tabs === 2
          ? "pharmacy"
          : this.tabs === 3
          ? "docsmart"
          : this.tabs === 4
          ? "diagnostics-lab"
          : this.tabs === 5
          ? "bloodbank"
          : "ambulance";
      this.$http
        .get(`${API_URL}/v2/admin/get-charges-settings?role=${role}`)
        .then(
          (response) => {
            if (response.body.status) {
              if (this.tabs === 0) {
                this.accountDataForDoctorRole = {
                  utilityCharge: response.body.data.settings.utility_charges,
                  cancellationCharge:
                    response.body.data.settings.cancellation_charges,
                  sameAsUtilityCharge:
                    response.body.data.settings
                      .set_cancellation_charges_same_as_utility_charge,
                  videoFees: response.body.data.settings.video_fees,
                  appointmentType: "APPOINTMENT",
                  docsmartCommisions:
                    response.body.data.settings.docsmart_commission,
                };
                this.$forceUpdate();
              } else if (this.tabs === 1) {
                this.accountDataForAlliedRole = {
                  utilityCharge: response.body.data.settings.utility_charges,
                  cancellationCharge:
                    response.body.data.settings.cancellation_charges,
                  sameAsUtilityCharge:
                    response.body.data.settings
                      .set_cancellation_charges_same_as_utility_charge,
                  videoFees: response.body.data.settings.video_fees,
                  appointmentType: "APPOINTMENT",
                  docsmartCommisions:
                    response.body.data.settings.docsmart_commission,
                };
              } else if (this.tabs === 2) {
                this.accountDataForPharmacyRole = {
                  utilityCharge: response.body.data.settings.utility_charges,
                  cancellationCharge:
                    response.body.data.settings.cancellation_charges,
                  sameAsUtilityCharge:
                    response.body.data.settings
                      .set_cancellation_charges_same_as_utility_charge,
                  appointmentType: "PHARMACY_BOOKING",
                  docsmartCommisions:
                    response.body.data.settings.docsmart_commission,
                };
              } else if (this.tabs === 3) {
                this.accountDataForDocsmartRole = {
                  utilityCharge: response.body.data.settings.utility_charges,
                  cancellationCharge:
                    response.body.data.settings.cancellation_charges,
                  sameAsUtilityCharge:
                    response.body.data.settings
                      .set_cancellation_charges_same_as_utility_charge,
                };
              } else if (this.tabs === 4) {
                this.accountDataForDiagnosticRole = {
                  utilityCharge: response.body.data.settings.utility_charges,
                  cancellationCharge:
                    response.body.data.settings.cancellation_charges,
                  sameAsUtilityCharge:
                    response.body.data.settings
                      .set_cancellation_charges_same_as_utility_charge,
                  appointmentType: "DIAGNOSTIC_BOOKING",
                  docsmartCommisions:
                    response.body.data.settings.docsmart_commission,
                };
              }
              // else if (this.tabs === 5) {
              //   this.accountDataForBloodbankRole = {
              //     utilityCharge: response.body.data.settings.utility_charges,
              //     cancellationCharge:
              //       response.body.data.settings.cancellation_charges,
              //     sameAsUtilityCharge:
              //       response.body.data.settings
              //         .set_cancellation_charges_same_as_utility_charge,
              //     appointmentType: "BLOODBANK_BOOKING",
              //     docsmartCommisions:
              //       response.body.data.settings.docsmart_commission,
              //   };
              // } else if (this.tabs === 6) {
              //   this.accountDataForAmbulanceRole = {
              //     utilityCharge: response.body.data.settings.utility_charges,
              //     cancellationCharge:
              //       response.body.data.settings.cancellation_charges,
              //     sameAsUtilityCharge:
              //       response.body.data.settings
              //         .set_cancellation_charges_same_as_utility_charge,
              //     appointmentType: "AMBULANCE_BOOKING",
              //     docsmartCommisions:
              //       response.body.data.settings.docsmart_commission,
              //   };
              // }
              this.showPage = true;
            }
          },
          (err) => {
            console.log(err);
          }
        );
    },
  },
};
</script>
